import { Container } from "../../components/HOC/container"
import { useContext, useState } from "react"
import { Rate } from "antd"
import { UserContext, UserContextType } from "../../shared/contexts"
import api from "../../app/api"
import style from "./Schedule.module.scss"
import { useTranslation } from "../../shared/hooks/useTranslation"
import { Button } from "../../components/button/button"

export function Schedule() {
  const { user } = useContext<UserContextType>(UserContext)
  const { t } = useTranslation()

  const [rating, setRating] = useState(0)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [isSubmitted, setIsSubmitted] = useState(false)

  if (!user || !user.serviceId || !user.doctorId || !user.date) {
    return <p className={style.error}>{t.missingInfo}</p>
  }

  const handleSubmitRating = async () => {
    if (rating === 0 || isSubmitting) return
    setIsSubmitting(true)
    try {
      // Отправляем отзыв об удобстве онлайн-записи (best-effort).
      await api.post("/feedback", {
        rating,
        doctorId: user.doctorId,
        serviceId: user.serviceId,
        iin: user.kimlikBilgisi?.IIN,
      })
    } catch {
      // Не блокируем благодарность, даже если бэкенд недоступен.
    } finally {
      setIsSubmitting(false)
      setIsSubmitted(true)
    }
  }

  return (
    <Container className={style.schedule}>
      <div className={style.successContainer}>
        <h1 className={style.title}>{t.scheduleTitle}</h1>
        <p className={style.subtitle}>{t.scheduleSubtitle}</p>

        <div className={style.infoContainer}>
          <div className={style.infoRow}>
            <span className={style.label}>{t.doctor}</span>
            <span className={style.value}>{user.doctorName}</span>
          </div>

          <div className={style.infoRow}>
            <span className={style.label}>{t.service}</span>
            <span className={style.value}>{user.serviceId}</span>
          </div>

          <div className={style.infoRow}>
            <span className={style.label}>{t.dateTime}</span>
            <span className={style.value}>{user.selectedDateTime}</span>
          </div>
        </div>

        {/* ── Форма оценки удобства онлайн-записи ── */}
        <div className={style.ratingCard}>
          {isSubmitted ? (
            <div className={style.ratingThanks}>
              <div className={style.ratingThanksIcon}>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M20 6 9 17l-5-5" />
                </svg>
              </div>
              <h3 className={style.ratingTitle}>{t.ratingThanksTitle}</h3>
              <p className={style.ratingSubtitle}>{t.ratingThanksSubtitle}</p>
            </div>
          ) : (
            <>
              <h3 className={style.ratingTitle}>{t.ratingTitle}</h3>
              <p className={style.ratingSubtitle}>{t.ratingSubtitle}</p>

              <Rate
                value={rating}
                onChange={setRating}
                className={style.ratingStars}
              />

              <Button
                onClick={handleSubmitRating}
                loading={isSubmitting}
                disabled={rating === 0}
                className={style.ratingSubmit}
              >
                {t.ratingSubmit}
              </Button>
            </>
          )}
        </div>
      </div>
    </Container>
  )
}
